import { Box, Container, Typography, Divider } from '@material-ui/core'

export interface ProductDetailsSectionProps {
  /**
   * "What we love about it" section content
   */
  whatWeLove?: string
  /**
   * "About this product" section content
   */
  about?: string
  /**
   * "Description" section content
   */
  description?: string
  /**
   * "Specs" section content
   */
  specs?: string
}

export default function ProductDetailsSection({
  whatWeLove,
  about,
  description,
  specs,
}: ProductDetailsSectionProps) {
  return (
    <Box>
      {whatWeLove && (
        <Box pb={4}>
          <Typography
            align="center"
            color="primary"
            component="h5"
            variant="body1"
            gutterBottom
          >
            WHAT WE LOVE ABOUT IT
          </Typography>
          <Container maxWidth="md">
            <Typography
              align="center"
              variant="h5"
              component="p"
              dangerouslySetInnerHTML={{ __html: whatWeLove }}
            />
          </Container>
        </Box>
      )}
      {about && (
        <Box pb={3}>
          <Typography
            color="primary"
            component="h2"
            variant="h5"
            align="center"
            gutterBottom
          >
            About This Product
          </Typography>
          <Divider />
          <Container maxWidth="md">
            <Typography
              dangerouslySetInnerHTML={{ __html: about }}
              component="p"
              variant="body1"
              paragraph
            />
          </Container>
        </Box>
      )}
      {description && (
        <Box pb={3}>
          <Typography
            color="primary"
            component="h2"
            variant="h5"
            align="center"
            gutterBottom
          >
            Description
          </Typography>
          <Divider />
          <Container maxWidth="md">
            <Typography
              dangerouslySetInnerHTML={{ __html: description }}
              component="p"
              variant="body1"
              paragraph
            />
          </Container>
        </Box>
      )}
      {specs && (
        <Box pb={3}>
          <Typography
            color="primary"
            component="h2"
            variant="h5"
            align="center"
            gutterBottom
          >
            Specs
          </Typography>
          <Divider />
          <Container maxWidth="md">
            <Typography
              dangerouslySetInnerHTML={{ __html: specs }}
              component="p"
              variant="body1"
              paragraph
            />
          </Container>
        </Box>
      )}
    </Box>
  )
}
